import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import translationService from '../services/translationService';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ className = '', showAllLanguages = false }) => {
  const { i18n } = useTranslation();
  const [detectedLanguage, setDetectedLanguage] = useState(null);

  const languages = [
    { code: 'en', name: 'EN', flag: 'US', fullName: 'English' },
    { code: 'nl', name: 'NL', flag: 'NL', fullName: 'Nederlands' }
  ];

  useEffect(() => {
    // Auto-detect user's preferred language on first visit
    const detectLanguage = async () => {
      const detected = await translationService.detectUserRegion();
      setDetectedLanguage(detected);
      
      // If no language is set and detected language is Dutch, suggest it
      if (!localStorage.getItem('preferred-language') && detected === 'nl') {
        const shouldSwitch = window.confirm(
          `We detected you might prefer Nederlands. Would you like to switch?`
        );
        if (shouldSwitch) {
          handleLanguageChange(detected);
        }
      }
    };

    detectLanguage();
  }, []);

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    translationService.setUserLanguage(languageCode);
    
    // Preload common translations for the new language
    if (languageCode !== 'en') {
      translationService.preloadCommonTranslations(languageCode);
    }
  };

  return (
    <div className={`language-switcher ${className}`}>
      {languages.map((language) => (
        <button
          key={language.code}
          onClick={() => handleLanguageChange(language.code)}
          className={`language-btn ${
            i18n.language === language.code ? 'active' : ''
          }`}
          title={`Switch to ${language.fullName || language.name}`}
        >
          <span className="flag"><ReactCountryFlag countryCode={language.flag} svg /></span>
          <span className="name">{language.name}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;